import React, { Fragment, useContext } from 'react';
import PropTypes from 'prop-types';
import AppContext from 'src/AppContext';
import { Popover, Button, Icon } from 'Components';
import DownloadFromUrl from 'helpers/download';
import i18n from 'i18next';
import { ADDITIONAL_ANALYSIS } from 'constants/apis';
import '../../../../components/PowerTable/PowerTablePopover/PowerTablePopover.css';

const AdditionTablePopover = ({ Id }) => {
  const { onAPIError } = useContext(AppContext);

  const handleClick = (e, URL) => {
    e.stopPropagation();
    DownloadFromUrl(URL).catch(({ response }) =>
      onAPIError(response, true),
    );
  };

  const data = [
    {
      Description: i18n.t('additionalAnalysis:AdditionDocument'),
      url: `${ADDITIONAL_ANALYSIS}/${Id}/PDF`,
    },
  ];

  return (
    <Fragment>
      <Button>
        <Icon icon="description" />
      </Button>
      <div className="power-table-popover__container">
        <Popover
          className="power-table-popover"
          placement="bottom-start"
          onClick={(e) => e.stopPropagation()}
        >
          {data.map((obj) => (
            <Button
              key={obj.Description}
              onClick={(e) => handleClick(e, obj.url)}
            >
              <div className="power-table-popover__item">
                <Icon icon="print" />
                <span>{obj.Description}</span>
              </div>
            </Button>
          ))}
        </Popover>
      </div>
    </Fragment>
  );
};

AdditionTablePopover.propTypes = {
  popoverRef: PropTypes.shape({}),
  Id: PropTypes.number,
};

export default AdditionTablePopover;



// WEBPACK FOOTER //
// ./src/containers/Jobs/AdditionTab/AdditionTablePopover/AdditionTablePopover.jsx